<template>
    <div>
        <div class="full-length-block">
            <div class="content-code">
                <div class="bottomRight-request">
                <p>{{$t('ExampleRequest')}}</p>
                <p>{{$t('token')}}</p>
                </div>
                <div class="preload-bg">
                <div class="preloadURL">
                <p>{{$t('curlGET')}} <span ref="url_link_add">'http://server-address:port/api/v2/auth/token?lifetime=20'</span></p>
                </div>
                <a href="#" @click.prevent="$parent.handleCopy($refs.url_link_add)" class="copyURL"><feather type="copy"></feather> </a>
                </div>
            </div>
            <div class="content">
                <div class="overflow-hidden content-section" id="content-get-started">
                    <div class="api-information">
                        <div class="folder-name"><p class="headTitle">{{$t('Auth')}}</p></div>
                        <div class="folder-description"></div>
                    </div>
                    <div class="api-information">
                        <div class="heading">
                        <div class="name addIcon">
                            <span class="GET method green" title="GET">{{$t('GET')}}</span>
                            {{$t('token')}} <feather type="lock"></feather>
                            <span class="lock-icon"></span>
                        </div>
                        </div>
                        <div class="url">http://server-address:port/api/v2/auth/token?lifetime=20</div>
                        <div class="description request-description">
                        <p>{{$t('authMsz')}}</p>
                        <div class="desc_code">
                            <pre class="click-to-expand-wrapper is-snippet-wrapper  language-undefined">
                                <code class=" is-highlighted language-undefined">{
    "success": true,
    "message": "token",
    "result": "cW6gzixF"
}
                                </code>
                                
                            </pre>
                        </div>
                        </div>
                        <div class="authorization-info" id="auth-info-">
                        <div class="heading"> {{$t('AUTHORIZATION')}} <span class="auth-type"> {{$t('DigestAuth')}} </span> </div>
                        </div> 
                        <div class="query-params">
                        <div class="heading">{{$t('PARAMS')}}</div>
                            <hr>
                            <div class="param row justify-content-end">
                            <div class="name col-md-3 col-xs-12">{{$t('lifetime')}}</div>
                            <div class="value col-md-9 col-xs-12">20</div>
                                <div class="description col-md-9 col-xs-12">
                                <p>{{$t('tokenLifeMint')}}</p>
                                </div>
                            </div>
                        </div>  
                    </div> 
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name:'auth',
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/api_document/auth.vue